/**
 * Opens GovX verification from the cart drawer without routing shoppers away
 * from checkout flow. GovX's app script exposes GovXIdApi.popup after load; the
 * fallback keeps the action usable if the app script is still loading.
 */
(function () {
  if (window.__mcGovxCartBound) return;
  window.__mcGovxCartBound = true;

  function isGovxVerifyUrl(url) {
    try {
      const parsed = new URL(url, window.location.href);
      return parsed.hostname === 'auth.govx.com' && parsed.pathname === '/shopify/verify';
    } catch (_error) {
      return false;
    }
  }

  function getGovxUrl(trigger) {
    return [
      trigger.dataset.govxHref,
      trigger.getAttribute('data-govx-href'),
      trigger.getAttribute('href'),
      trigger.href,
    ].find((url) => url && isGovxVerifyUrl(url));
  }

  function openGovxPopup(url) {
    if (window.GovXIdApi && typeof window.GovXIdApi.popup === 'function') {
      window.GovXIdApi.popup(url);
      return;
    }

    const width = 450;
    const height = 700;
    const left = Math.max(0, window.screenX + ((window.innerWidth || document.documentElement.clientWidth) - width) / 2);
    const top = Math.max(0, window.screenY + ((window.innerHeight || document.documentElement.clientHeight) - height) / 2);
    window.open(url, 'GOVX ID Authorization', `width=${width},height=${height},top=${top},left=${left}`);
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target?.closest?.('[data-mc-govx-cart]');
    if (!trigger) return;

    const url = getGovxUrl(trigger);
    if (!url) return;

    event.preventDefault();
    event.stopPropagation();
    openGovxPopup(url);
  }, true);
})();
